import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/functions'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyC2BhezOY3_QGcJ6C8ap2-szceew5m3fRw",
  authDomain: "pink-workout.firebaseapp.com",
  projectId: "pink-workout",
  storageBucket: "pink-workout.appspot.com",
  messagingSenderId: "497386086752",
  appId: "1:497386086752:web:2738b87edbbbe8413a3e05",
  measurementId: "G-61P5L5LF1G"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

//Use emulator
// if (location.hostname === "localhost") {
//   firebaseApp.firestore().useEmulator("localhost", 8080)
//   firebaseApp.auth().useEmulator("http://localhost:9099")
//   firebaseApp.functions().useEmulator("localhost", 5001)
// }

export default firebaseApp.firestore()